import { ax } from '../utils/axios/axios'
import { BASE_API_URL } from '../constants'

interface CreateCostItemOptions {
  drsId: string,
  roleId: string,
  itemDescription: string,
  itemPrice: number,
}

export const apiDRSCostItemCreate = ({
  drsId,
  roleId,
  itemDescription,
  itemPrice,
}: CreateCostItemOptions) => {
	console.log("roleId ===", roleId);
  const options = {
    method: 'POST',
    url: `${BASE_API_URL}/drs/${drsId}/costItems`,
    params: {
      role: roleId,
      reqDev: 'web',
    },
    data: {
      itemDescription,
      itemPrice,
    },
  }
  return ax(options)
}
